<template>
  <el-dialog
    title="钻头入库"
    :visible.sync="visible"
    width="650px"
    @close="$emit('update:show', false)"
  >
    <el-form
      :model="model"
      :rules="rules"
      class="flex-form"
      ref="form"
      label-width="80px"
      size="small"
      inline
    >
      <template v-if="isGeneralStockroom">
        <el-form-item label="序列号" prop="serial_number">
          <el-input v-model="model.serial_number"></el-input>
        </el-form-item>
        <br />
        <el-form-item label="新旧" prop="is_new">
          <el-select v-model="model.is_new" style="width: 100%">
            <el-option
              v-for="(value, index) in DrillIsNewMap"
              :key="index"
              :label="value"
              :value="parseInt(index)"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="类型" prop="drill_type">
          <el-select v-model="model.drill_type" style="width: 100%">
            <el-option
              v-for="(value, index) in DrillTypeMap"
              :key="index"
              :label="value"
              :value="parseInt(index)"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="型号" prop="model_number">
          <el-input v-model="model.model_number"></el-input>
        </el-form-item>
        <el-form-item label="零件号" prop="component_number">
          <el-input v-model="model.component_number"></el-input>
        </el-form-item>
        <el-form-item label="规格" prop="specification">
          <el-input v-model="model.specification"></el-input>
        </el-form-item>
        <el-form-item label="包装" prop="package_type">
          <el-select v-model="model.package_type" style="width: 100%">
            <el-option
              v-for="(value, index) in DrillPackageType"
              :key="index"
              :label="value"
              :value="parseInt(index)"
            ></el-option>
          </el-select>
        </el-form-item>
      </template>
      <el-form-item label="序列号" prop="drill_id" v-else>
        <el-select
          size="small"
          placeholder="请搜索选择序列号"
          filterable
          remote
          :remote-method="getItems"
          :loading="loading"
          v-model="model.drill_id"
        >
          <el-option
            v-for="item in items"
            :key="item.id"
            :label="item.serial_number"
            :value="parseInt(item.id)"
          ></el-option>
        </el-select>
      </el-form-item>
      <br />
      <el-form-item label="入库类型" prop="stock_in_category">
        <el-select v-model="model.stock_in_category" style="width: 100%">
          <el-option
            v-for="(value, index) in DrillStockInCategoryMap"
            v-if="index != '5'"
            :key="index"
            :label="value"
            :value="parseInt(index)"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="状态" prop="stage">
        <el-select v-model="model.stage" style="width: 100%">
          <el-option
            v-for="(value, index) in DrillStageMap"
            v-if="parseInt(index) != 7"
            :key="index"
            :label="value"
            :value="parseInt(index)"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="备注" prop="stock_in_remark">
        <el-input type="textarea" v-model="model.stock_in_remark"></el-input>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">取 消</el-button>
      <el-button size="small" type="primary" @click="submitForm"
        >确 定</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import { drillRecordNew, drillRecordUpdate, drillList } from '@/service/getData'
import {
  DrillStockInCategoryMap,
  DrillStageMap,
  DrillTypeMap,
  DrillPackageType,
  DrillIsNewMap,
} from '@/config/global'

export default {
  props: {
    model: {
      type: Object,
    },
    show: {
      type: Boolean,
      default: false,
    },
    isGeneralStockroom: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    show() {
      this.visible = this.show
      if (!this.visible) {
        this.$refs.form.resetFields()
      } else {
        if (this.model.id && !this.isGeneralStockroom) {
          this.getItems(this.model.drill.serial_number)
        }
      }
    },
  },
  created() {},
  data() {
    return {
      DrillStockInCategoryMap,
      DrillStageMap,
      DrillTypeMap,
      DrillPackageType,
      DrillIsNewMap,
      visible: this.show,
      loading: false,
      items: [],
      rules: {
        serial_number: [{ required: true, message: '请输入序列号' }],
        stock_in_category: [{ required: true, message: '请选择入库类型' }],
        is_new: [{ required: true, message: '请选择新旧' }],
        drill_type: [{ required: true, message: '请选择钻头类型' }],
        model_number: [{ required: true, message: '请输入型号' }],
        specification: [{ required: true, message: '请输入规格' }],
        stage: [{ required: true, message: '请选择状态' }],
        package_type: [{ required: true, message: '请选择包装' }],
        component_number: [{ required: true, message: '请输入零件号' }],
      },
    }
  },
  methods: {
    async getItems(query) {
      if (query !== '') {
        this.loading = true
        let res = await drillList({ serial_number: query })
        if (res.status == 0) {
          this.items = res.data.list
          this.loading = false
        }
      } else {
        this.items = []
      }
    },
    submitForm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          let data = this.model
          if (this.model.id > 0) {
            let res = await drillRecordUpdate(data)
            if (res.status == 0) {
              this.$emit('updated', res.data)
            }
          } else {
            let res = await drillRecordNew(data)
            if (res.status == 0) {
              this.$emit('created', res.data)
            }
          }
          this.visible = false
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
  },
}
</script>

<style >
.el-form-item.long {
  width: 100%;
}
/* .flex-form {
  display: flex;
  flex-wrap: wrap;
} */
/* .el-input--small .el-input__inner {
  padding-right: 0 !important;
} */
.flex-form .el-form-item__content {
  width: 192px;
}
</style>